module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-attributes"
  }, [_c('div', {
    staticClass: "attributes-list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('selectize-vehicle-attribute', {
    staticClass: "input-group-field",
    on: {
      "optionSelected": _vm.updateAttributes
    }
  }), _c('div', {
    staticClass: "input-group-button"
  }, [_c('button', {
    staticClass: "button fa fa-plus",
    on: {
      "click": _vm.addAttribute
    }
  })])], 1)])])]), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.value), function(attribute, index) {
    return _c('div', {
      staticClass: "prop-item"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-label"
    }, [_vm._v(_vm._s(attribute.name))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "input-group-field",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (attribute.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attribute, "value", $event.target.value)
        }
      }
    }), _c('div', {
      staticClass: "input-group-button"
    }, [_c('button', {
      staticClass: "button default save",
      attrs: {
        "disabled": _vm.value[index].value == null || _vm.value[index].value == '' || _vm.disabled || _vm.spin
      },
      on: {
        "click": function($event) {
          return _vm.saveAttribute(attribute)
        }
      }
    }, [(_vm.spin) ? _c('span', {
      staticClass: "fa fa-spinner fa-spin",
      class: {
        spin: _vm.spin
      }
    }) : _c('span', {
      staticClass: "fa fa-save"
    })]), _c('button', {
      staticClass: "button warning fa",
      attrs: {
        "disabled": _vm.disabled || _vm.spin
      },
      on: {
        "click": function($event) {
          return _vm.removeAttribute(index)
        }
      }
    }, [(_vm.spin) ? _c('span', {
      staticClass: "fa fa-spinner fa-spin",
      class: {
        spin: _vm.spin
      }
    }) : _c('span', {
      staticClass: "fa fa-times"
    })])])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c669985a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/Attributes.vue
// module id = 2693
// module chunks = 1